import React from "react"
import { Box, Flex, Grid, Heading, Text, Container } from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"
import { GatsbyImage } from "gatsby-plugin-image"

const ImageAndText = ({ block }) => {
  // console.log("block", block)
  const { image, rightAligned, fullBackground } = block
  const { title, body, label, subtitle } = block.content
  return (
    <Box sx={{ position: "relative" }}>
      {fullBackground && (
        <Box
          sx={{
            position: ["absolute"],
            width: ["100%", "100%", fullBackground ? "100%" : "80%"],
            height: "100%",
            top: 0,
            left: rightAligned ? null : 0,
            right: rightAligned ? 0 : null,
            ".gatsby-image-wrapper": {
              height: "100%",
            },
          }}
        >
          {image && <GatsbyImage image={image.gatsbyImageData} alt="" />}
        </Box>
      )}
      <Container
        sx={{
          zIndex: 1,
          position: "relative",
          pt: [5, 5, 9],
          pb: [5, 5, fullBackground ? 9 : 5],
          mb: [0, 0, fullBackground ? 0 : 5],
        }}
      >
        {label && <Text color="dark">{label}</Text>}
        {title !== "EMPTY" && (
          <Heading
            as="h2"
            variant="h1"
            sx={{
              fontWeight: "400",
              fontSize: [6, 8],
              mb: [0, 0, 5],
            }}
          >
            {title}
          </Heading>
        )}

        <Grid
          columns={[
            1,
            1,
            rightAligned
              ? !fullBackground
                ? "1fr 1fr"
                : "4fr 1fr"
              : "1fr 1fr",
            rightAligned
              ? !fullBackground
                ? "1fr 1fr"
                : "4fr 1fr"
              : "1fr 1fr",
          ]}
          gap={[0, 0, 32]}
          sx={{ position: "relative" }}
        >
          {!rightAligned && <Box></Box>}
          <Flex
            sx={{
              flexDirection: "column",
              py: [0],
            }}
          >
            <Box
              sx={{
                maxWidth: !fullBackground ? "440px" : "",
              }}
            >
              {subtitle && (
                <Heading
                  color="dark"
                  as="h3"
                  variant="h3"
                  sx={{
                    mt: [0, 0],
                    fontWeight: "300",
                    mb: [5, 7],
                  }}
                >
                  {subtitle}
                </Heading>
              )}
            </Box>
            <Box>
              <RichContentStructuredText text={body} theme="light" />
            </Box>
          </Flex>
          {rightAligned && <Box></Box>}
        </Grid>
      </Container>
      {!fullBackground && (
        <Box
          sx={{
            zIndex: 0,
            top: 0,
            position: ["relative", "relative", "absolute"],
            width: "100%",
            height: "100%",
            left: [0, "50%"],
            transform: [null, "translateX(-50%)"],
            mb: [6, 6, 0],
            // maxWidth: "1440px",
          }}
        >
          <Grid
            columns={[
              1,
              1,
              rightAligned
                ? !fullBackground
                  ? "1fr 1fr"
                  : "4fr 1fr"
                : "1fr 1fr",
              rightAligned
                ? !fullBackground
                  ? "1fr 1fr"
                  : "4fr 1fr"
                : "1fr 1fr",
            ]}
            gap={[0, 0, 64]}
            sx={{
              py: [0, 0, 4],
              position: "relative",
              height: "100%",
              alignItems: "flex-end",
            }}
          >
            {rightAligned && <Box></Box>}
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: rightAligned ? "flex-end" : "flex-start",
                alignItems: "flex-end",
                position: ["relative"],
                width: ["100%", "100%", fullBackground ? "100%" : "100%"],
                height: "100%",
                top: 0,
                right: 0,
                ".gatsby-image-wrapper": {
                  height: "100%",
                  width: "100%",
                  borderRadius: "0 75px",
                  overflow: "hidden",
                  // maxWidth: "639px",
                  maxHeight: "550px",
                },
              }}
            >
              {image && <GatsbyImage image={image.gatsbyImageData} alt="" />}
            </Box>
          </Grid>
        </Box>
      )}
    </Box>
  )
}

export default ImageAndText
